import styled from 'styled-components';
import Modal from 'components/Core/Modal';

const StyledModal = styled(Modal)`
  .tools-roi-section--container {
    padding: 0;
  }
`;

const Container = styled.div`
  height: ${({ ratio }) => (ratio <= 1 ? '80vh' : '')};
  width: ${({ ratio }) => (ratio <= 1 ? 'auto' : '1100px')};
  max-width: 100%;
  margin: 0 auto;
  position: relative;

  .wistia-video {
    width: ${({ ratio }) => (ratio <= 1 ? 'auto' : '1100px')};
    height: ${({ ratio }) => (ratio <= 1 ? '80vh' : '')};
    max-width: 100%;
    aspect-ratio: ${({ ratio }) => ratio};
    margin: 0 auto;
    border-radius: ${({ includesCta }) => (includesCta ? '10px 10px 0 0' : '10px')};
    overflow: hidden;
  }
  h4 {
    color: var(--white);
  }
  .tags {
    margin: 50px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    h5,
    h6 {
      margin: 0 25px 0 0;
      color: var(--white);
    }
    h6:last-child {
      margin-right: 0;
    }
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 20px;
    width: max-content;
    &:hover {
      cursor: pointer;
      background: var(--grey-8);
    }
    &.active {
      background: #454545;
    }
    &.close {
      padding: 0;
      &:hover {
        background: transparent;
      }
    }
  }
  .close-button {
    color: var(--white);
    width: max-content;
    position: absolute;
    top: -45px;
    right: 0;
    font-size: 24px;
    top: 20px;
    right: 30px;
    z-index: 9;

    &:hover {
      cursor: pointer;
    }
  }

  @media (max-width: 575px) {
    .close-button {
      top: -25px;
      right: 0;
    }
  }
`;

export { Container, StyledModal };
